export default __webpack_public_path__ + "static/media/15094@2x.34126906.png";